document.addEventListener('DOMContentLoaded', function () {
    $('.gift_card_box+.read_more').click(function () {
        $(this).siblings('.gift_card_box').find('.icons_text').slideToggle();
        $(this).children('span').toggleClass('hide');
    });

    $('.grid__item .card_desc .tip_box').click(function () {
        $(this).find('.tip_dialog').removeClass('hide')
    })
    $('.card_desc .tip_box .close').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).parent('.tip_dialog').addClass('hide')
    })
})